import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const myPostcodesRoute: RouteConfig<'with-page'> = {
    name: 'My Postcodes',
    path: '/work-opps/my-postcodes',
    page: lazy(() => import('.')),
    context: 'member',
    flags: ['member-route'],
    permissions: ['workOps'],
}
